// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b109ab51","787":"252d6723","802":"3d62eaef"}[chunkId] + ".chunk.js";
};